/* eslint max-params: ["error", 6] */

import { PageType } from "@/components/Joyspace/const";
import { IContextRender } from "../components/List/ContextMenu";
import { ICategory, IPage } from "../components/List/types";
import { getPermissions, IPermissions, PermissionEnum } from "../permissions";
// 页面控制模块
import edit from "./page.edit";
import download from "./page.download";
import shortcut from "./page.shortcut";
import remove from "./page.remove";
import removeRecent from "./page.remove.recent";
import clone from "./page.clone";
import shared from "./page.shared";
import pageMove from "./page.move";
import rename from "./page.rename";
import copy from "./page.copy";
import sync from "./page.sync";
import collaborate from "./page.collaborate";
// import teamCreate from './page.create.team';
// 类目控制模块
// import categoryShortcut from './category.shortcut';
import categoryMove from "./category.move";
import categoryRemove from "./category.remove";
import categoryRename from "./category.rename";
import categorySetname from "./category.setname";
import categorySecurity from "./category.securitySet";
import { GlobalContextConfig } from "@/context/GlobalContext";
export { default as api } from "../api";
import collect from "./page.collect";
// import security from './page.securitySet';
import { SyncStatusEunm } from "../controllers/JoyspaceController";
import { notUseJoySpaceOffline } from "../util";
import { useNavigator } from "@/utils/NetworkCheck";
import tagRemove from "./tag.remove";

type IContextParameters<T> = Parameters<IContextRender<T>>;

export type IPageAddCallback = (
  o: IContextParameters<IPage>[1],
  isAllow: boolean,
  isTeam?: boolean,
  globalContext?: GlobalContextConfig,
  currentRouterInfo?: any,
  type?: string
) => Parameters<IContextParameters<IPage>[0]> | undefined;

export type ICategoryAddCallback = (
  o: IContextParameters<ICategory>[1],
  isAllow: boolean,
  isTeam: boolean
) => Parameters<IContextParameters<ICategory>[0]> | undefined;

// FOLDER_CREATE("FOLDER_CREATE", "创建文件夹"),
// FOLDER_REMOVE("FOLDER_REMOVE", "删除文件夹"),
// FOLDER_EDIT("FOLDER_EDIT", "修改文件夹"),
// FOLDER_MOVE("FOLDER_MOVE", "文件夹移动"),
// FOLDER_SHARE_CREATE("FOLDER_SHARE_CREATE", "新增协作者"),
// FOLDER_SHARE_REMOVE("FOLDER_SHARE_REMOVE", "删除协作者"),
// FOLDER_PUBLIC_SET("FOLDER_PUBLIC_SET", "设置公开文件夹"),

// // 文件相关 (8)
// PAGE_READ("PAGE_READ", "阅读文档"),
// PAGE_EDIT("PAGE_EDIT", "编辑文档"),
// PAGE_REMOVE("PAGE_REMOVE", "删除文档"),
// PAGE_MOVE("PAGE_MOVE", "文件移动"),
// PAGE_COPY("PAGE_COPY", "复制"),
// PAGE_COPY_CREATE("PAGE_COPY_CREATE", "创建副本"),
// // 文件分享
// SHARE_CREATE("SHARE_CREATE", "新增分享"),
// SHARE_REMOVE("SHARE_REMOVE", "删除分享"),

export enum Names {
  "RECENT" = "RECENT",
  "SHARES" = "SHARES",
  "MY_SHARE" = "MY_SHARE",
  "MY_SPACE" = "MY_SPACE",
  "TEAM_SPACE" = "TEAM_SPACE",
  "ZHUANBAN" = "ZHUANBAN",
  "GROUP" = "GROUP"
}
// 文档离线其它按钮控制，（不包括打开、删除、同步）
function isAllowPageFn(data: any) {
  return notUseJoySpaceOffline() ? true : useNavigator.onLine && !data.isNew;
}

// 同步按钮控制
function isAllowPageSyncFn(data: any) {
  return notUseJoySpaceOffline() ? true : useNavigator.onLine;
}

// 打开按钮控制
function isAllowPageOpenFn(data: any) {
  if (notUseJoySpaceOffline()) {
    return true;
  }
  if (data.syncStatus === SyncStatusEunm.DATAERROR || data.syncStatus === SyncStatusEunm.PROCESS) {
    return false;
  }
  return true;
}
// 删除按钮控制
function isAllowPageDelFn(data: any) {
  if (notUseJoySpaceOffline()) {
    return true;
  }
  // console.log(data, 'data===>', !useNavigator.onLine  && !data.isNew);
  if (data.isNew && !useNavigator.onLine && data.syncStatus === SyncStatusEunm.WAITING) {
    return true;
  } else if (
    (data.isNew && data.syncStatus === SyncStatusEunm.WAITING) ||
    data.syncStatus === SyncStatusEunm.PROCESS
  ) {
    return false;
  } else if (!useNavigator.onLine && !data.isNew) {
    return false;
  }
  return true;
}
function page(
  name?: keyof typeof Names,
  globalContext?: GlobalContextConfig,
  currentRouterInfo?: any,
  gname = "",
  from?: string
): IContextRender<IPage> {
  // eslint-disable-next-line complexity
  return (addOption, props) => {
    const _props = { ...props, gname, name, from };
    // console.log(props, 'propspropspropspropsprops');
    const option = (cb: IPageAddCallback, isAllow = true) => {
      let res = cb(
        _props,
        isAllow,
        name === Names.TEAM_SPACE || name === Names.ZHUANBAN || name === Names.GROUP,
        globalContext,
        currentRouterInfo,
        name
      );
      if (res) {
        res[0].from = name;
        addOption.apply(null, res);
      }
    };
    const permissions = props.data.permissions || [];
    if (props.data.page_type === PageType.Form) {
      option(edit, isAllowPageOpenFn(props.data));
      // option(shortcut);
      // option(addto);
      if (name === Names.RECENT) {
        option(removeRecent, isAllowPageFn(props.data));
      }
    } else {
      // (name === Names.MY_SPACE || name === Names.TEAM_SPACE || e) &&
      //     option(
      //         edit,
      //         name === Names.MY_SPACE ||
      //             (permissions.includes(PermissionEnum.PAGE_EDIT) &&
      //                 name === Names.TEAM_SPACE)
      //     );
      option(edit, isAllowPageOpenFn(props.data));
      // 安全设置
      // option(security, isAllowPageOpenFn(props.data));
      // 分享
      // (name === Names.MY_SPACE || name === Names.TEAM_SPACE) &&
      option(
        shared as any,
        permissions.includes(PermissionEnum.SHARE_CREATE) && isAllowPageFn(props.data)
      );
      // 管理协作者
      option(
        collaborate,
        permissions.includes(PermissionEnum.SHARE_MANAGE) && isAllowPageFn(props.data)
      );

      option(
        rename,
        (name === Names.MY_SPACE || permissions.includes(PermissionEnum.PAGE_EDIT)) &&
          isAllowPageFn(props.data)
      );
      option(
        download,
        permissions.includes(PermissionEnum.PAGE_DOWNLOAD) && isAllowPageFn(props.data)
      );
      // 收藏
      name !== Names.GROUP && option(collect as any, isAllowPageFn(props.data));
      name !== Names.GROUP && option(shortcut, isAllowPageFn(props.data));

      option(
        copy,
        (name === Names.MY_SPACE || permissions.includes(PermissionEnum.PAGE_COPY)) &&
          isAllowPageFn(props.data)
      );

      (name === Names.MY_SPACE || name === Names.TEAM_SPACE || name === Names.GROUP) &&
        option(
          pageMove,
          (name === Names.MY_SPACE ||
            (permissions.includes(PermissionEnum.PAGE_MOVE) && name === Names.TEAM_SPACE) ||
            (permissions.includes(PermissionEnum.PAGE_MOVE) && name === Names.GROUP)) &&
            isAllowPageFn(props.data)
        );
      (name === Names.MY_SPACE || name === Names.TEAM_SPACE || name === Names.GROUP) &&
        option(
          clone,
          (name === Names.MY_SPACE ||
            (permissions.includes(PermissionEnum.PAGE_COPY_CREATE) && name === Names.TEAM_SPACE) ||
            (permissions.includes(PermissionEnum.PAGE_COPY_CREATE) && name === Names.GROUP)) &&
            isAllowPageFn(props.data)
        );

      if (name === Names.RECENT) {
        option(removeRecent, isAllowPageFn(props.data));
      }
      (name === Names.MY_SPACE || name === Names.TEAM_SPACE || name === Names.GROUP) &&
        option(
          remove,
          (name === Names.MY_SPACE ||
            (permissions.includes(PermissionEnum.PAGE_REMOVE) && name === Names.TEAM_SPACE) ||
            (permissions.includes(PermissionEnum.PAGE_REMOVE) && name === Names.GROUP)) &&
            isAllowPageDelFn(props.data)
        );
      // 只有 同步失败，在显示同步按钮，并且 离线时置灰，在线在可以点击。
      props.data.syncStatus === SyncStatusEunm.ERROR && option(sync, isAllowPageSyncFn(props.data));

      // option(openPageQrCode);
    }
  };
}

// 文档离线其它按钮控制，（不包括打开、删除、同步）
function isAllowCategoryFn(data = null) {
  return useNavigator.onLine;
}

function category(name?: keyof typeof Names, currentRouterInfo?: any): IContextRender<ICategory> {
  // let permissions: IPermissions = {};
  // // console.log(name, spaceId, 'spaceIdspaceIdspaceId');
  // getPermissions(spaceId).then((data) => {
  //     permissions = data;
  // });
  /* eslint complexity: ["error", 30] */
  // eslint-disable-next-line complexity
  return (addOption, props) => {
    // console.log(addOption, 'addOption', props);
    const option = (cb: ICategoryAddCallback, isAllow = true) => {
      const res = cb(props, isAllow, name === Names.TEAM_SPACE || name === Names.GROUP);
      // console.log(res, 'resresresresresresres');
      res && addOption.apply(null, res);
    };
    const permissions = props.data.permissions || [];
    // 分享
    ((name === Names.MY_SPACE && props.data.parent === props.data.space_id) ||
      (name === Names.TEAM_SPACE && !props.data.parent)) &&
      option(
        shared as any,
        (name === Names.MY_SPACE ||
          (name === Names.TEAM_SPACE && permissions.includes(PermissionEnum.SHARE_CREATE))) &&
          isAllowCategoryFn()
      );
    // 管理协作者
    name === Names.TEAM_SPACE &&
      !props.data.parent &&
      option(
        collaborate as any,
        name === Names.TEAM_SPACE &&
          permissions.includes(PermissionEnum.SHARE_MANAGE) &&
          isAllowCategoryFn()
      );
    // 设置
    ((name === Names.MY_SPACE && props.data.parent === props.data.space_id) ||
      (name === Names.TEAM_SPACE && !props.data.parent)) &&
      option(
        categorySetname,
        (name === Names.MY_SPACE ||
          (name === Names.TEAM_SPACE && permissions.includes(PermissionEnum.FOLDER_EDIT))) &&
          isAllowCategoryFn()
      );
    name === Names.TEAM_SPACE &&
      permissions.includes(PermissionEnum.FOLDER_SET_SECURE) &&
      !props.data.parent &&
      option(
        categorySecurity,
        name === Names.TEAM_SPACE &&
          permissions.includes(PermissionEnum.FOLDER_SET_SECURE) &&
          isAllowCategoryFn()
      );
    // 重命名
    ((name === Names.MY_SPACE && props.data.parent !== props.data.space_id) ||
      (name === Names.TEAM_SPACE && props.data.parent) ||
      (name === Names.GROUP && props.data.parent)) &&
      option(
        categoryRename,
        (name === Names.MY_SPACE ||
          (name === Names.TEAM_SPACE && permissions.includes(PermissionEnum.FOLDER_EDIT)) ||
          (name === Names.GROUP && permissions.includes(PermissionEnum.FOLDER_EDIT))) &&
          isAllowCategoryFn()
      );
    // 收藏
    name !== Names.GROUP && option(collect as any, isAllowCategoryFn());
    name !== Names.GROUP && option(shortcut as any, isAllowCategoryFn());
    (name === Names.MY_SPACE || name === Names.TEAM_SPACE || name === Names.GROUP) &&
      option(
        categoryMove,
        (name === Names.MY_SPACE ||
          (name === Names.TEAM_SPACE && permissions.includes(PermissionEnum.FOLDER_MOVE)) ||
          (name === Names.GROUP && permissions.includes(PermissionEnum.FOLDER_MOVE))) &&
          isAllowCategoryFn()
      );
    (name === Names.MY_SPACE || name === Names.TEAM_SPACE || name === Names.GROUP) &&
      option(
        categoryRemove,
        (name === Names.MY_SPACE ||
          (name === Names.TEAM_SPACE && permissions.includes(PermissionEnum.FOLDER_REMOVE)) ||
          (name === Names.GROUP && permissions.includes(PermissionEnum.FOLDER_REMOVE))) &&
          isAllowCategoryFn()
      );
  };
}

function tags(
  name?: keyof typeof Names,
  globalContext?: GlobalContextConfig,
  currentRouterInfo?: any,
  gname = "",
  from?: string
): IContextRender<IPage> {
  /* eslint complexity: ["error", 30] */
  // eslint-disable-next-line complexity
  return (addOption, props) => {
    const _props = { ...props, gname, name, from };
    // console.log(props, 'propspropspropspropsprops');
    const option = (cb: IPageAddCallback, isAllow = true) => {
      let res = cb(
        _props,
        isAllow,
        name === Names.TEAM_SPACE || name === Names.ZHUANBAN || name === Names.GROUP,
        globalContext,
        currentRouterInfo
      );
      if (res) {
        res[0].from = name;
        addOption.apply(null, res);
      }
    };
    option(edit, true);
    option(tagRemove, true);
  };
}
export default {
  page,
  category,
  tags
};
